(function() {
    'use strict';

    angular.module("settings")
        .controller('TranslationListController', TranslationListController);

    TranslationListController.$inject = ['translationDataSrvc', 'searchFilterSrvc', 'notificationSrvc', 'lodashService', 'datatableDefaultPageSizeValueConst', 'checkSearchSrvc', 'translationPermissionsConst', 'filterQuerySrvc'];

    function TranslationListController(translationDataSrvc, searchFilterSrvc, notificationSrvc, lodashService, datatableDefaultPageSizeValueConst, checkSearchSrvc, translationPermissionsConst, filterQuerySrvc) {
        var self = this;

        self.loading = true;

        self.pageOpts = {
            count: undefined,
            page: 1,
            pageSize: datatableDefaultPageSizeValueConst
        };

        self.emptyCheckboxColumns = ['de', 'en', 'cpde', 'cpen'];
        self.emptyColumnsList = [];
        self.columnEmptyCheckboxChange = columnEmptyCheckboxChange;

        self.translationRows = [];
        self.translationCols = [{
            title: 'Moduł',
            value: 'module',
            type: 'text',
            searchable: true,
            orderable: true,
            isEditable: false
        }, {
            title: 'Typ',
            value: 'type',
            type: 'text',
            searchable: true,
            orderable: true,
            isEditable: false
        }, {
            title: 'Kontroller',
            value: 'controller',
            type: 'text',
            searchable: true,
            orderable: true,
            isEditable: false
        }, {
            title: 'Nr',
            value: 'number',
            type: 'number',
            searchable: true,
            orderable: true,
            isEditable: false
        }, {
            title: 'Tekst',
            value: 'text',
            type: 'text',
            searchable: true,
            orderable: true,
            isEditable: false
        }, {
            title: 'Polski',
            value: 'pl',
            type: 'text',
            searchable: true,
            orderable: true,
            isEditable: true,
            required: false
        }, {
            title: 'Niemiecki',
            value: 'de',
            type: 'text',
            searchable: true,
            orderable: true,
            isEditable: true,
            required: false
        }, {
            title: 'Angielski',
            value: 'en',
            type: 'text',
            searchable: true,
            orderable: true,
            isEditable: true,
            required: false
        }, {
            title: 'Niemiecki (de)',
            value: 'cpde',
            type: 'text',
            searchable: true,
            orderable: true,
            isEditable: true,
            required: false
        }, {
            title: 'Angielski (de)',
            value: 'cpen',
            type: 'text',
            searchable: true,
            orderable: true,
            isEditable: true,
            required: false
        }];
        self.modelPermissions = translationPermissionsConst;

        self.searchQuery = {
            module: null,
            type: null,
            controller: null,
            number: null,
            text: null,
            pl: null,
            de: null,
            en: null,
            cpde: null,
            cpen: null,
            ordering: null,
            onlyEmptyColumns: null
        };

        self.onEdit = onEdit;

        self.pageChange = pageChange;
        self.onSearchQueryChange = onSearchQueryChange;

        activate();

        function activate() {
            self.pageOpts = filterQuerySrvc.initializePageOpts(self.pageOpts);
            self.searchQuery = filterQuerySrvc.initializeSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            getTranslations();
        }

        function getTranslations(filterObj) {
            if (!filterObj) {
                filterObj = {
                    page: self.pageOpts.page,
                    page_size: self.pageOpts.pageSize,
                    module: self.searchQuery.module || null,
                    type: self.searchQuery.type || null,
                    controller: self.searchQuery.controller || null,
                    number: self.searchQuery.number || null,
                    text: self.searchQuery.text || null,
                    pl: self.searchQuery.pl || null,
                    de: self.searchQuery.de || null,
                    en: self.searchQuery.en || null,
                    cpde: self.searchQuery.cpde || null,
                    cpen: self.searchQuery.cpen || null,
                    ordering: self.searchQuery.ordering,
                    onlyEmptyColumns: self.emptyColumnsList
                };
            }
            return translationDataSrvc.list(filterObj)
                .$promise
                .then(
                    function(response) {
                        self.translationRows = response.results;
                        self.pageOpts.count = response.count;
                        return response;
                    },
                    function(response) {
                        if (response.status === 404 && filterObj.page !== 1) {
                            checkSearchSrvc.recall(filterObj, getTranslations);
                        }
                    }
                ).finally(
                    function(response) {
                        self.loading = false;
                        return response;
                    }
                );
        }

        function onEdit(row) {
            return translationDataSrvc.update({}, row);
        }

        function pageChange() {
            filterQuerySrvc.updatePageOpts(self.pageOpts);
            filterQuerySrvc.setLocationParams();
            return getTranslations();
        }

        function onSearchQueryChange() {
            self.pageOpts.page = 1;
            filterQuerySrvc.updatePageOpts(self.pageOpts);
            filterQuerySrvc.updateSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            return getTranslations();
        }

        function columnEmptyCheckboxChange(selectedColumns) {
            self.emptyColumnsList = Object.keys(selectedColumns).map(function(key) {
                if (selectedColumns[key]){
                    return key;
                }
            });
            self.emptyColumnsList = self.emptyColumnsList.filter(function (el) {
                return el != null;
            });
            filterQuerySrvc.updatePageOpts(self.pageOpts);
            self.searchQuery['onlyEmptyColumns'] = self.emptyColumnsList;
            filterQuerySrvc.updateSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            return getTranslations();
        }
    }
})();
